import { useState, useRef, useEffect } from 'react'

// ============================================================================
// BANCO DE PREGUNTAS
// ----------------------------------------------------------------------------
// Listening y Reading tienen ahora 2 preguntas por nivel (una "base" y una
// "confirmacion"). Esto es lo que hace el examen verificable: con una sola
// pregunta de opcion multiple (4 opciones) un estudiante tiene 25% de
// probabilidad de acertar por puro azar. Exigiendo que acierte AMBAS
// preguntas del mismo nivel para que ese nivel quede "confirmado", la
// probabilidad de que el azar infle el resultado baja a 6.25% (1/16).
// Ademas, el nivel final ya no se calcula como un promedio de porcentajes:
// se calcula subiendo nivel por nivel (A1 -> A2 -> B1 -> B2 -> C1) y el
// estudiante solo avanza al siguiente nivel si confirmo el anterior al 100%.
// Ver evaluarNivelSecuencial() mas abajo.
// ============================================================================

const PREGUNTAS = [
  // ---------------------------------------------------------------- LISTENING
  {
    id: 'l1', habilidad: 'listening', nivel: 'A1',
    tipo: 'audio_opcion',
    instruccion: 'Escucha la frase y elige la respuesta correcta.',
    audio_texto: 'Hello, my name is Sarah. I am twenty years old and I am from Canada.',
    pregunta: 'Como se llama la persona que habla?',
    opciones: ['Emily', 'Sarah', 'Anna', 'Laura'],
    correcta: 1
  },
  {
    id: 'l1b', habilidad: 'listening', nivel: 'A1',
    tipo: 'audio_opcion',
    instruccion: 'Escucha la frase y elige la respuesta correcta. (Confirmacion de nivel A1)',
    audio_texto: 'Hi, I am Mark. I am thirty years old. I am from Australia.',
    pregunta: 'De donde es Mark?',
    opciones: ['Canada', 'Australia', 'England', 'Ireland'],
    correcta: 1
  },
  {
    id: 'l2', habilidad: 'listening', nivel: 'A2',
    tipo: 'audio_opcion',
    instruccion: 'Escucha y elige la respuesta correcta.',
    audio_texto: 'The restaurant opens at twelve o clock and closes at ten at night. It is closed on Sundays.',
    pregunta: 'A que hora abre el restaurante?',
    opciones: ['10:00 AM', '11:00 AM', '12:00 PM', '1:00 PM'],
    correcta: 2
  },
  {
    id: 'l2b', habilidad: 'listening', nivel: 'A2',
    tipo: 'audio_opcion',
    instruccion: 'Escucha y elige la respuesta correcta. (Confirmacion de nivel A2)',
    audio_texto: 'The supermarket is open from eight in the morning until nine at night, every day except Sunday, when it closes at six.',
    pregunta: 'A que hora cierra el supermercado los domingos?',
    opciones: ['6:00 PM', '8:00 PM', '9:00 PM', '9:00 AM'],
    correcta: 0
  },
  {
    id: 'l3', habilidad: 'listening', nivel: 'B1',
    tipo: 'audio_opcion',
    instruccion: 'Escucha la conversacion y responde.',
    audio_texto: 'Good morning, I would like to book a table for four people on Saturday night. We have availability at eight thirty or ten. I prefer eight thirty, please.',
    pregunta: 'A que hora quedo la reserva?',
    opciones: ['7:00 PM', '8:00 PM', '8:30 PM', '10:00 PM'],
    correcta: 2
  },
  {
    id: 'l3b', habilidad: 'listening', nivel: 'B1',
    tipo: 'audio_opcion',
    instruccion: 'Escucha la conversacion y responde. (Confirmacion de nivel B1)',
    audio_texto: 'I would like to change my flight to Friday morning. I know there is a fee, but I need to arrive before the conference starts on Friday afternoon.',
    pregunta: 'Por que quiere cambiar el vuelo la persona?',
    opciones: ['Porque perdio su pasaporte', 'Porque el vuelo se cancelo', 'Porque necesita llegar antes de una conferencia', 'Porque el precio bajo'],
    correcta: 2
  },
  {
    id: 'l4', habilidad: 'listening', nivel: 'B2',
    tipo: 'audio_opcion',
    instruccion: 'Escucha con atencion y elige la mejor respuesta.',
    audio_texto: 'Climate change is one of the most important challenges of our time. Scientists warn that if we do not take urgent action, the consequences will be irreversible for future generations.',
    pregunta: 'Cual es el mensaje principal de esta afirmacion?',
    opciones: [
      'El cambio climatico no es un problema real',
      'Los cientificos no estan de acuerdo sobre el cambio climatico',
      'Se necesita accion urgente para evitar consecuencias irreversibles',
      'Las futuras generaciones resolveran el cambio climatico'
    ],
    correcta: 2
  },
  {
    id: 'l4b', habilidad: 'listening', nivel: 'B2',
    tipo: 'audio_opcion',
    instruccion: 'Escucha con atencion y elige la mejor respuesta. (Confirmacion de nivel B2)',
    audio_texto: 'Despite significant investment in renewable energy, many countries still rely heavily on fossil fuels, mainly because switching entirely would require infrastructure that does not yet exist.',
    pregunta: 'Segun el audio, por que muchos paises siguen dependiendo de combustibles fosiles?',
    opciones: [
      'Porque no creen en la energia renovable',
      'Porque no existe aun la infraestructura necesaria para el cambio completo',
      'Porque los combustibles fosiles son mas baratos siempre',
      'Porque el gobierno lo prohibe'
    ],
    correcta: 1
  },
  {
    id: 'l5', habilidad: 'listening', nivel: 'C1',
    tipo: 'audio_opcion',
    instruccion: 'Escucha el fragmento academico y responde.',
    audio_texto: 'Globalization has profoundly transformed economic and social structures. While it has facilitated cultural and commercial exchange, it has also generated significant inequalities between developed and developing nations.',
    pregunta: 'Que sugiere el hablante sobre la globalizacion?',
    opciones: [
      'Solo tiene efectos positivos en la sociedad',
      'Tiene tanto beneficios como desventajas',
      'Deberia detenerse por completo',
      'Solo afecta a los paises desarrollados'
    ],
    correcta: 1
  },
  {
    id: 'l5b', habilidad: 'listening', nivel: 'C1',
    tipo: 'audio_opcion',
    instruccion: 'Escucha el fragmento academico y responde. (Confirmacion de nivel C1)',
    audio_texto: 'The committee acknowledged that, although the proposal had considerable merit, its implementation would be contingent upon securing additional funding that, at present, remains uncertain.',
    pregunta: 'Que condicion menciona el comite para implementar la propuesta?',
    opciones: [
      'Que el publico la apruebe',
      'Que se consiga financiamiento adicional, el cual aun no es seguro',
      'Que se cancele otro proyecto',
      'Que pase un año de revision'
    ],
    correcta: 1
  },

  // ------------------------------------------------------------------ READING
  {
    id: 'r1', habilidad: 'reading', nivel: 'A1',
    tipo: 'texto_opcion',
    instruccion: 'Lee el texto y responde la pregunta.',
    texto: 'My name is John. I am 25 years old. I am a doctor. I live in Toronto with my family. I like soccer and music.',
    pregunta: 'Cual es la profesion de John?',
    opciones: ['Profesor', 'Ingeniero', 'Doctor', 'Abogado'],
    correcta: 2
  },
  {
    id: 'r1b', habilidad: 'reading', nivel: 'A1',
    tipo: 'texto_opcion',
    instruccion: 'Lee el texto y responde la pregunta. (Confirmacion de nivel A1)',
    texto: 'My name is Anna. I am 30 years old. I am a teacher. I live in Vancouver with my two cats.',
    pregunta: 'Cuantos gatos tiene Anna?',
    opciones: ['Uno', 'Dos', 'Tres', 'Ninguno'],
    correcta: 1
  },
  {
    id: 'r2', habilidad: 'reading', nivel: 'A2',
    tipo: 'texto_opcion',
    instruccion: 'Lee y elige la respuesta correcta.',
    texto: 'The Royal Ontario Museum was founded in 1912. It is one of the largest museums in Canada and is located in downtown Toronto. It has more than 13 million items in its permanent collection.',
    pregunta: 'En que año se fundo el museo?',
    opciones: ['1900', '1912', '1950', '2000'],
    correcta: 1
  },
  {
    id: 'r2b', habilidad: 'reading', nivel: 'A2',
    tipo: 'texto_opcion',
    instruccion: 'Lee y elige la respuesta correcta. (Confirmacion de nivel A2)',
    texto: 'The CN Tower is located in Toronto. It was completed in 1976 and was the tallest free-standing structure in the world for over 30 years.',
    pregunta: 'En que año se completo la CN Tower?',
    opciones: ['1966', '1976', '1986', '1996'],
    correcta: 1
  },
  {
    id: 'r3', habilidad: 'reading', nivel: 'B1',
    tipo: 'texto_opcion',
    instruccion: 'Lee el texto con atencion y responde.',
    texto: 'Poutine is a traditional Canadian dish made with french fries, cheese curds and gravy. This dish originated in Quebec in the 1950s and has become one of the most iconic foods in Canada.',
    pregunta: 'En que decada se origino el poutine?',
    opciones: ['1930s', '1950s', '1970s', '1990s'],
    correcta: 1
  },
  {
    id: 'r3b', habilidad: 'reading', nivel: 'B1',
    tipo: 'texto_opcion',
    instruccion: 'Lee el texto con atencion y responde. (Confirmacion de nivel B1)',
    texto: 'Maple syrup production in Canada usually takes place in early spring, when temperatures rise above freezing during the day but still drop below freezing at night, causing sap to flow.',
    pregunta: 'Cuando ocurre la produccion de jarabe de arce?',
    opciones: ['A finales del verano', 'A principios de la primavera', 'En pleno invierno', 'A finales del otoño'],
    correcta: 1
  },
  {
    id: 'r4', habilidad: 'reading', nivel: 'B2',
    tipo: 'texto_opcion',
    instruccion: 'Lee el siguiente texto y responde.',
    texto: 'Remote work has fundamentally changed how companies operate. Studies show that employees who work from home report higher job satisfaction, though some companies struggle to maintain team cohesion and company culture in a distributed environment.',
    pregunta: 'Segun el texto, que dificultad enfrentan algunas empresas?',
    opciones: [
      'Los empleados estan menos satisfechos',
      'Mantener la cohesion de equipo y la cultura empresarial',
      'Los costos han aumentado significativamente',
      'La productividad ha disminuido'
    ],
    correcta: 1
  },
  {
    id: 'r4b', habilidad: 'reading', nivel: 'B2',
    tipo: 'texto_opcion',
    instruccion: 'Lee el siguiente texto y responde. (Confirmacion de nivel B2)',
    texto: 'While social media has enabled unprecedented connectivity, researchers increasingly point out that excessive use may contribute to feelings of isolation, contradicting its original purpose of bringing people together.',
    pregunta: 'Segun el texto, que contradiccion señalan los investigadores?',
    opciones: [
      'Que las redes sociales cuestan demasiado dinero',
      'Que el uso excesivo puede generar aislamiento en lugar de conexion',
      'Que nadie usa las redes sociales ya',
      'Que las redes sociales son ilegales en algunos paises'
    ],
    correcta: 1
  },
  {
    id: 'r5', habilidad: 'reading', nivel: 'C1',
    tipo: 'texto_opcion',
    instruccion: 'Lee este texto academico y elige la mejor interpretacion.',
    texto: 'Artificial intelligence, far from being merely a technological tool, represents a paradigm shift that challenges our fundamental assumptions about cognition, creativity, and the nature of intelligence itself.',
    pregunta: 'Segun el texto, la inteligencia artificial se describe mejor como:',
    opciones: [
      'Simplemente una herramienta tecnologica avanzada',
      'Un cambio de paradigma que desafia suposiciones fundamentales',
      'Una amenaza para el empleo humano',
      'Un concepto puramente teorico sin aplicaciones reales'
    ],
    correcta: 1
  },
  {
    id: 'r5b', habilidad: 'reading', nivel: 'C1',
    tipo: 'texto_opcion',
    instruccion: 'Lee este texto academico y elige la mejor interpretacion. (Confirmacion de nivel C1)',
    texto: 'The notion that economic growth alone guarantees societal wellbeing has been increasingly challenged by scholars who argue that metrics such as income equality and environmental sustainability are equally, if not more, indicative of a nation\'s true prosperity.',
    pregunta: 'Que argumentan los academicos mencionados en el texto?',
    opciones: [
      'Que el crecimiento economico es lo unico que importa',
      'Que la igualdad de ingresos y la sostenibilidad ambiental tambien son indicadores clave de prosperidad',
      'Que el crecimiento economico ya no es posible',
      'Que la sostenibilidad ambiental no tiene relacion con la prosperidad'
    ],
    correcta: 1
  },

  // ------------------------------------------------------------------ WRITING
  // (Se mantienen como estimacion inicial; Writing siempre lo confirma un
  // profesor certificado, igual que en examenes tipo Cambridge/Oxford.)
  {
    id: 'w1', habilidad: 'writing', nivel: 'A1',
    tipo: 'completar',
    instruccion: 'Completa la frase con la palabra correcta.',
    pregunta: 'My name ___ Laura and I am twenty years old.',
    opciones: ['are', 'is', 'am', 'be'],
    correcta: 1
  },
  {
    id: 'w2', habilidad: 'writing', nivel: 'A2',
    tipo: 'completar',
    instruccion: 'Elige la opcion correcta para completar la frase.',
    pregunta: 'Yesterday I ___ to the movies with my friends and we watched a great film.',
    opciones: ['go', 'going', 'went', 'will go'],
    correcta: 2
  },
  {
    id: 'w3', habilidad: 'writing', nivel: 'B1',
    tipo: 'completar',
    instruccion: 'Selecciona la forma verbal correcta.',
    pregunta: 'If I had more time, I ___ learn how to play guitar.',
    opciones: ['want', 'would', 'wanted', 'will'],
    correcta: 1
  },
  {
    id: 'w4', habilidad: 'writing', nivel: 'B2',
    tipo: 'texto_libre',
    instruccion: 'Escribe 2-3 frases en ingles describiendo tu rutina diaria. Usa al menos un verbo reflexivo.',
    pregunta: 'Describe tu rutina diaria en ingles:',
    minPalabras: 15
  },
  {
    id: 'w5', habilidad: 'writing', nivel: 'C1',
    tipo: 'texto_libre',
    instruccion: 'Escribe un parrafo corto en ingles (4-5 frases) dando tu opinion sobre la importancia de aprender idiomas.',
    pregunta: 'Da tu opinion sobre aprender idiomas:',
    minPalabras: 30
  },
  { id: 's1', habilidad: 'speaking', nivel: 'A1', tipo: 'grabacion_libre', duracionMinima: 10 },
  { id: 's2', habilidad: 'speaking', nivel: 'A2', tipo: 'grabacion_libre', duracionMinima: 15 },
  { id: 's3', habilidad: 'speaking', nivel: 'B1', tipo: 'grabacion_libre', duracionMinima: 20 },
  { id: 's4', habilidad: 'speaking', nivel: 'B2', tipo: 'grabacion_libre', duracionMinima: 25 },
  { id: 's5', habilidad: 'speaking', nivel: 'C1', tipo: 'grabacion_libre', duracionMinima: 30 },
]

const TOPICS_SPEAKING = [
  'Describe your favorite place in your city and explain why you like it.',
  'Talk about a hobby or activity you enjoy in your free time.',
  'Describe your typical morning routine, from waking up to leaving home.',
  'Talk about a memorable trip or vacation you have taken.',
  'Describe your family and explain what you like about spending time with them.',
  'Talk about your favorite type of food and why you enjoy it.',
  'Describe a skill you would like to learn and explain why.',
  'Talk about the advantages and disadvantages of living in a big city.',
  'Describe your dream job and explain why it appeals to you.',
  'Talk about a book, movie or show that had an impact on you.',
  'Discuss the importance of learning a second language.',
  'Talk about how technology has changed the way people communicate.',
  'Describe a challenge you have faced and how you overcame it.',
  'Discuss the pros and cons of remote work versus working in an office.',
  'Talk about an important tradition or celebration in your culture.',
  'Describe what a perfect weekend looks like for you.',
  'Discuss whether social media has a positive or negative impact on society.',
  'Talk about a person who has influenced you and explain why.',
]

function elegirTemasAlAzar(cantidad) {
  const barajado = [...TOPICS_SPEAKING].sort(() => Math.random() - 0.5)
  return barajado.slice(0, cantidad)
}

// Orden oficial de niveles usado en toda la plataforma (coincide con la
// tabla `niveles` en la base de datos: PRE, A1, A2, B1, B2, C1, C2).
const ORDEN_NIVELES = ['PRE', 'A1', 'A2', 'B1', 'B2', 'C1', 'C2']

// getNivel: se usa unicamente para Writing/Speaking, que son un ESTIMADO
// (el nivel real de esas dos habilidades lo confirma un profesor). Incluye
// un piso 'PRE' para no forzar a alguien con puntaje muy bajo a quedar en A1.
function getNivel(puntaje) {
  if (puntaje >= 90) return 'C2'
  if (puntaje >= 75) return 'C1'
  if (puntaje >= 60) return 'B2'
  if (puntaje >= 45) return 'B1'
  if (puntaje >= 25) return 'A2'
  if (puntaje >= 10) return 'A1'
  return 'PRE'
}

// Puntaje simple (porcentaje de aciertos) de una habilidad completa.
// Se sigue mostrando como referencia visual, pero para Listening/Reading
// el nivel oficial YA NO sale de este numero: sale de evaluarNivelSecuencial().
function getPuntajePorHabilidad(respuestas, habilidad) {
  const pregsHab = PREGUNTAS.filter(p => p.habilidad === habilidad)
  let correctas = 0
  pregsHab.forEach(p => {
    const r = respuestas[p.id]
    if (p.tipo === 'audio_opcion' || p.tipo === 'texto_opcion' || p.tipo === 'completar') {
      if (r === p.correcta) correctas++
    } else if (p.tipo === 'texto_libre') {
      if (r && r.trim().split(/\s+/).filter(Boolean).length >= (p.minPalabras || 5)) correctas++
    } else if (p.tipo === 'grabacion_libre') {
      if (r?.duracion >= (p.duracionMinima || 15)) correctas++
    }
  })
  return Math.round((correctas / pregsHab.length) * 100)
}

// ============================================================================
// evaluarNivelSecuencial
// ----------------------------------------------------------------------------
// Nucleo de la nueva logica de calificacion objetiva (Listening y Reading).
// En lugar de promediar porcentajes, sube nivel por nivel desde A1:
//   - Si el estudiante acierta las 2 preguntas de un nivel -> nivel CONFIRMADO,
//     se sigue evaluando el siguiente nivel.
//   - Si acierta solo 1 de 2, o ninguna -> la escalada se detiene AHI. No
//     importa si acerto por azar preguntas de niveles mas altos: no se le
//     puede acreditar un nivel que no domino de forma consistente.
//   - Si ni siquiera confirma A1, el resultado es 'PRE' (nivel piso, es decir
//     necesita empezar por lo basico: alfabeto, numeros, saludos).
// Esto es lo que hace el test "real y verificable": exige dominio
// consecutivo demostrado, no una casualidad estadistica.
// ============================================================================
function evaluarNivelSecuencial(respuestas, habilidad) {
  const niveles = ['A1', 'A2', 'B1', 'B2', 'C1']
  let nivelConfirmado = 'PRE'
  const detalle = {}

  for (const nivel of niveles) {
    const preguntasNivel = PREGUNTAS.filter(p => p.habilidad === habilidad && p.nivel === nivel)
    const aciertos = preguntasNivel.reduce((acc, p) => acc + (respuestas[p.id] === p.correcta ? 1 : 0), 0)
    const total = preguntasNivel.length
    const confirmado = total > 0 && aciertos === total

    detalle[nivel] = { aciertos, total, confirmado }

    if (confirmado) {
      nivelConfirmado = nivel
    } else {
      break // se detiene la escalada: no se evaluan niveles superiores
    }
  }

  return { nivel: nivelConfirmado, detalle }
}

function nivelMinimo(a, b) {
  const ia = ORDEN_NIVELES.indexOf(a)
  const ib = ORDEN_NIVELES.indexOf(b)
  if (ia === -1) return b
  if (ib === -1) return a
  return ORDEN_NIVELES[Math.min(ia, ib)]
}

const COLORES_NIVEL = {
  PRE:'#94A3B8', A1:'#22C55E', A2:'#3B82F6', B1:'#8B5CF6', B2:'#F59E0B', C1:'#EF4444', C2:'#0D1F52'
}
const HABILIDADES_INFO = {
  listening: { ic:'🎧', label:'Listening', color:'#3B82F6', autoCalificado: true  },
  reading:   { ic:'📖', label:'Reading',   color:'#22C55E', autoCalificado: true  },
  writing:   { ic:'✍️', label:'Writing',   color:'#8B5CF6', autoCalificado: false },
  speaking:  { ic:'🎤', label:'Speaking',  color:'#EF4444', autoCalificado: false },
}

function GrabadorSpeaking({ tema, duracionMinima, onGrabacionLista }) {
  const [fase,     setFase]     = useState('lista')
  const [segundos, setSegundos] = useState(0)
  const [audioUrl, setAudioUrl] = useState(null)
  const [errorMic, setErrorMic] = useState('')

  const mediaRecorderRef = useRef(null)
  const chunksRef        = useRef([])
  const blobRef          = useRef(null)
  const intervalRef      = useRef(null)
  const DURACION_MAX     = 90

  useEffect(() => () => clearInterval(intervalRef.current), [])

  function iniciarPreparacion() {
    setFase('preparando')
    setSegundos(15)
    intervalRef.current = setInterval(() => {
      setSegundos(s => {
        if (s <= 1) { clearInterval(intervalRef.current); iniciarGrabacion(); return 0 }
        return s - 1
      })
    }, 1000)
  }

  async function iniciarGrabacion() {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
      const mr = new MediaRecorder(stream)
      chunksRef.current = []
      mr.ondataavailable = e => chunksRef.current.push(e.data)
      mr.onstop = () => {
        const blob = new Blob(chunksRef.current, { type: 'audio/webm' })
        blobRef.current = blob
        setAudioUrl(URL.createObjectURL(blob))
        stream.getTracks().forEach(t => t.stop())
      }
      mr.start()
      mediaRecorderRef.current = mr
      setFase('grabando')
      setSegundos(0)
      intervalRef.current = setInterval(() => {
        setSegundos(s => {
          if (s + 1 >= DURACION_MAX) { detenerGrabacion(); return DURACION_MAX }
          return s + 1
        })
      }, 1000)
    } catch (err) {
      setErrorMic('No se pudo acceder al microfono. Revisa los permisos del navegador.')
      setFase('lista')
    }
  }

  function detenerGrabacion() {
    clearInterval(intervalRef.current)
    mediaRecorderRef.current?.stop()
    setFase('listo')
  }

  function regrabar() {
    setAudioUrl(null)
    setSegundos(0)
    setFase('lista')
  }

  function confirmar() {
    onGrabacionLista({ duracion: segundos, audioUrl, blob: blobRef.current })
  }

  const suficiente = segundos >= duracionMinima

  return (
    <div>
      <div style={{ background:'rgba(255,255,255,0.08)', borderRadius:12, padding:20, marginBottom:16 }}>
        <div style={{ fontSize:11, fontWeight:700, color:'#F0D878', textTransform:'uppercase', letterSpacing:1, marginBottom:8 }}>
          Your topic
        </div>
        <p style={{ fontSize:16, lineHeight:1.6, margin:0 }}>{tema}</p>
      </div>

      {errorMic && (
        <div style={{ background:'rgba(239,68,68,0.15)', border:'1px solid rgba(239,68,68,0.4)', borderRadius:10, padding:'10px 14px', fontSize:13, marginBottom:16, color:'#FCA5A5' }}>
          {errorMic}
        </div>
      )}

      {fase === 'lista' && (
        <div style={{ textAlign:'center', padding:'20px 0' }}>
          <p style={{ fontSize:13, opacity:.7, marginBottom:16 }}>
            Tendras 15 segundos para prepararte, luego se grabara tu respuesta (minimo {duracionMinima}s, maximo {DURACION_MAX}s).
          </p>
          <button onClick={iniciarPreparacion}
            style={{ background:'#EF4444', color:'#fff', border:'none', borderRadius:12, padding:'14px 32px', fontFamily:'inherit', fontSize:15, fontWeight:700, cursor:'pointer' }}>
            🎙 Empezar
          </button>
        </div>
      )}

      {fase === 'preparando' && (
        <div style={{ textAlign:'center', padding:'20px 0' }}>
          <div style={{ fontSize:13, opacity:.7, marginBottom:10 }}>Prepara tu respuesta...</div>
          <div style={{ fontSize:48, fontWeight:900, color:'#F0D878' }}>{segundos}</div>
        </div>
      )}

      {fase === 'grabando' && (
        <div style={{ textAlign:'center', padding:'20px 0' }}>
          <div style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:10, marginBottom:14 }}>
            <div style={{ width:12, height:12, borderRadius:'50%', background:'#EF4444', animation:'pulseGrab 1s infinite' }} />
            <span style={{ fontSize:13, fontWeight:700 }}>Grabando...</span>
          </div>
          <style>{`@keyframes pulseGrab { 0%,100% { opacity:1; } 50% { opacity:.3; } }`}</style>
          <div style={{ fontSize:36, fontWeight:900, marginBottom:16 }}>{segundos}s</div>
          <button onClick={detenerGrabacion}
            style={{ background:'#374151', color:'#fff', border:'none', borderRadius:12, padding:'12px 28px', fontFamily:'inherit', fontSize:14, fontWeight:700, cursor:'pointer' }}>
            ⏹ Detener
          </button>
        </div>
      )}

      {fase === 'listo' && (
        <div style={{ textAlign:'center', padding:'10px 0' }}>
          <div style={{ fontSize:13, marginBottom:10, color: suficiente ? '#86EFAC' : '#FCA5A5' }}>
            {suficiente ? '✅ Duracion suficiente' : `⚠ Muy corta, minimo ${duracionMinima}s (grabaste ${segundos}s)`}
          </div>
          <audio controls src={audioUrl} style={{ width:'100%', maxWidth:340, marginBottom:16 }} />
          <div style={{ display:'flex', gap:10, justifyContent:'center' }}>
            <button onClick={regrabar}
              style={{ background:'rgba(255,255,255,0.1)', color:'#fff', border:'1px solid rgba(255,255,255,0.3)', borderRadius:10, padding:'10px 20px', fontFamily:'inherit', fontSize:13, fontWeight:600, cursor:'pointer' }}>
              🔄 Grabar de nuevo
            </button>
            <button onClick={confirmar} disabled={!suficiente}
              style={{ background: suficiente ? '#22C55E' : 'rgba(255,255,255,0.15)', color:'#fff', border:'none', borderRadius:10, padding:'10px 24px', fontFamily:'inherit', fontSize:13, fontWeight:700, cursor: suficiente ? 'pointer' : 'not-allowed' }}>
              ✅ Usar esta grabacion
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

// Chip visual para el desglose "por que quedaste en este nivel" del resultado.
function ChipNivel({ nivel, info }) {
  const estado = !info ? 'pendiente' : info.confirmado ? 'confirmado' : info.aciertos > 0 ? 'parcial' : 'fallido'
  const estilos = {
    confirmado: { bg:'rgba(34,197,94,0.18)', border:'rgba(34,197,94,0.5)', texto:'#86EFAC', icono:'✅' },
    parcial:    { bg:'rgba(245,158,11,0.18)', border:'rgba(245,158,11,0.5)', texto:'#FCD34D', icono:'➖' },
    fallido:    { bg:'rgba(239,68,68,0.18)', border:'rgba(239,68,68,0.5)', texto:'#FCA5A5', icono:'✖' },
    pendiente:  { bg:'rgba(255,255,255,0.06)', border:'rgba(255,255,255,0.15)', texto:'rgba(255,255,255,0.4)', icono:'—' },
  }[estado]
  return (
    <div style={{ background: estilos.bg, border:'1px solid ' + estilos.border, borderRadius:10, padding:'8px 6px', textAlign:'center', flex:1 }}>
      <div style={{ fontSize:11, fontWeight:800, color:'#fff', marginBottom:2 }}>{nivel}</div>
      <div style={{ fontSize:13 }}>{estilos.icono}</div>
      <div style={{ fontSize:9, color: estilos.texto, marginTop:2 }}>{info ? `${info.aciertos}/${info.total}` : ''}</div>
    </div>
  )
}

export default function ExamenNivel({ onTerminar, onSaltar, onVolver }) {
  const [paso,       setPaso]       = useState('intro')
  const [pregActual, setPregActual] = useState(0)
  const [respuestas, setRespuestas] = useState({})
  const [textoLibre, setTextoLibre] = useState('')
  const [resultado,  setResultado]  = useState(null)
  const [cargando,   setCargando]   = useState(false)
  const [temasSpeaking] = useState(() => elegirTemasAlAzar(5))

  function hablar(texto) {
    if (!window.speechSynthesis) return
    window.speechSynthesis.cancel()
    const u = new SpeechSynthesisUtterance(texto)
    u.lang = 'en-US'; u.rate = 0.85
    const voces = window.speechSynthesis.getVoices()
    const voz = voces.find(v => v.lang === 'en-US') || voces.find(v => v.lang.startsWith('en'))
    if (voz) u.voice = voz
    window.speechSynthesis.speak(u)
  }

  const pregunta = PREGUNTAS[pregActual]
  const habilidadActual = pregunta?.habilidad
  const progreso = Math.round((pregActual / PREGUNTAS.length) * 100)

  const speakingIds = PREGUNTAS.filter(p => p.habilidad === 'speaking').map(p => p.id)
  const temaActual = pregunta?.tipo === 'grabacion_libre' ? temasSpeaking[speakingIds.indexOf(pregunta.id)] : null

  function responder(valor) {
    setRespuestas(prev => ({ ...prev, [pregunta.id]: valor }))
  }

  function siguiente() {
    if (pregunta.tipo === 'texto_libre') {
      responder(textoLibre)
      setTextoLibre('')
    }
    if (pregActual < PREGUNTAS.length - 1) {
      setPregActual(i => i + 1)
    } else {
      calcularResultado()
    }
  }

  function anterior() {
    if (pregActual > 0) {
      setPregActual(i => i - 1)
      setTextoLibre('')
    } else {
      setPaso('intro')
    }
  }

  function calcularResultado() {
    setCargando(true)

    // Nivel base real: Listening + Reading, evaluados con escalada
    // secuencial (ver evaluarNivelSecuencial arriba). Estos son los unicos
    // datos 100% objetivos y auto-calificables sin ambiguedad.
    const evalListening = evaluarNivelSecuencial(respuestas, 'listening')
    const evalReading    = evaluarNivelSecuencial(respuestas, 'reading')

    // El nivel objetivo final es el MINIMO entre Listening y Reading (no el
    // promedio). Es la opcion mas conservadora y defendible: si el
    // estudiante domina Reading en B1 pero Listening solo en A2, no tiene
    // sentido ubicarlo en B1 — se ubica en A2 y refuerza Listening ahi.
    const nivelObjetivo = nivelMinimo(evalListening.nivel, evalReading.nivel)

    // Puntajes en porcentaje (solo como referencia visual / progreso).
    const pL = getPuntajePorHabilidad(respuestas, 'listening')
    const pR = getPuntajePorHabilidad(respuestas, 'reading')
    const pW = getPuntajePorHabilidad(respuestas, 'writing')
    const pS = getPuntajePorHabilidad(respuestas, 'speaking')
    const pTotalObjetivo = Math.round((pL + pR) / 2)

    // Recopilamos las respuestas de escritura y los datos de las grabaciones
    // para enviarlas a revision docente (no se pueden calificar con precision
    // real sin que un profesor certificado las revise, igual que en Oxford/Cambridge).
    const escritura = PREGUNTAS
      .filter(p => p.habilidad === 'writing' && p.tipo === 'texto_libre')
      .map(p => ({ pregunta: p.pregunta, nivel: p.nivel, texto: respuestas[p.id] || '' }))

    const grabaciones = PREGUNTAS
      .filter(p => p.habilidad === 'speaking')
      .map(p => ({
        pregunta_id: p.id,
        nivel: p.nivel,
        tema: temasSpeaking[speakingIds.indexOf(p.id)],
        duracion: respuestas[p.id]?.duracion || 0,
        blob: respuestas[p.id]?.blob || null
      }))

    const res = {
      puntaje_listening: pL, puntaje_reading: pR,
      puntaje_writing_estimado: pW, puntaje_speaking_estimado: pS,
      puntaje_total_objetivo: pTotalObjetivo,
      nivel_listening: evalListening.nivel,
      nivel_reading: evalReading.nivel,
      nivel_writing_estimado: getNivel(pW),
      nivel_speaking_estimado: getNivel(pS),
      nivel_objetivo: nivelObjetivo,
      detalle_listening: evalListening.detalle,
      detalle_reading: evalReading.detalle,
      completado: true
    }

    setTimeout(() => {
      setResultado(res)
      setPaso('resultado')
      setCargando(false)
    }, 600)

    // Pasamos todo hacia arriba (App.js lo retiene hasta que el estudiante se registre,
    // momento en el que se envia por correo al equipo docente)
    window.__examenDatosParaRevision = { escritura, grabaciones }
  }

  function continuarAResultado() {
    onTerminar(resultado, window.__examenDatosParaRevision)
  }

  function puedeAvanzar() {
    if (!pregunta) return false
    if (pregunta.tipo === 'audio_opcion' || pregunta.tipo === 'texto_opcion' || pregunta.tipo === 'completar') {
      return respuestas[pregunta.id] !== undefined
    }
    if (pregunta.tipo === 'texto_libre') {
      return textoLibre.trim().split(/\s+/).filter(Boolean).length >= (pregunta.minPalabras || 5)
    }
    if (pregunta.tipo === 'grabacion_libre') {
      return respuestas[pregunta.id]?.duracion >= (pregunta.duracionMinima || 15)
    }
    return false
  }

  if (paso === 'intro') return (
    <div style={{ minHeight:'100vh', background:'linear-gradient(145deg,#0D1F52,#1B3A8C,#0a1836)', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:'system-ui, sans-serif', padding:20, position:'relative' }}>
      {onVolver && (
        <button onClick={onVolver}
          style={{ position:'absolute', top:24, left:24, background:'none', border:'none', cursor:'pointer', fontSize:14, color:'rgba(255,255,255,0.6)', fontFamily:'inherit', display:'flex', alignItems:'center', gap:6 }}>
          ← Volver
        </button>
      )}
      <div style={{ background:'rgba(255,255,255,0.05)', backdropFilter:'blur(20px)', border:'1px solid rgba(255,255,255,0.15)', borderRadius:24, padding:48, maxWidth:600, width:'100%', textAlign:'center', color:'#fff' }}>
        <div style={{ fontSize:64, marginBottom:16 }}>🎯</div>
        <h1 style={{ fontSize:28, fontWeight:900, marginBottom:8 }}>Examen de nivel de ingles</h1>
        <p style={{ fontSize:16, opacity:.8, marginBottom:24, lineHeight:1.6 }}>
          Descubre tu nivel real de ingles en {PREGUNTAS.length} preguntas: Listening, Reading, Writing y Speaking.
        </p>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(2,1fr)', gap:12, marginBottom:16 }}>
          {Object.entries(HABILIDADES_INFO).map(([key, info]) => (
            <div key={key} style={{ background:'rgba(255,255,255,0.08)', borderRadius:12, padding:'14px 16px', display:'flex', alignItems:'center', gap:10 }}>
              <span style={{ fontSize:24 }}>{info.ic}</span>
              <div style={{ textAlign:'left' }}>
                <div style={{ fontSize:14, fontWeight:700 }}>{info.label}</div>
                <div style={{ fontSize:10, opacity:.6 }}>{info.autoCalificado ? 'Auto-calificado' : 'Revision docente'}</div>
              </div>
            </div>
          ))}
        </div>
        <div style={{ background:'rgba(59,130,246,0.12)', border:'1px solid rgba(59,130,246,0.4)', borderRadius:12, padding:'12px 16px', marginBottom:16, textAlign:'left', display:'flex', gap:10 }}>
          <span style={{ fontSize:18 }}>🔒</span>
          <div style={{ fontSize:13, opacity:.85 }}>
            Listening y Reading tienen <strong>2 preguntas por nivel</strong>. Para que un nivel cuente, debes acertar
            las dos — asi el resultado no depende de la suerte y refleja tu dominio real.
          </div>
        </div>
        <div style={{ background:'rgba(212,175,55,0.12)', border:'1px solid rgba(212,175,55,0.4)', borderRadius:12, padding:'12px 16px', marginBottom:16, textAlign:'left', display:'flex', gap:10 }}>
          <span style={{ fontSize:18 }}>👨‍🏫</span>
          <div style={{ fontSize:13, opacity:.85 }}>
            Igual que en Oxford o Cambridge: Listening y Reading se califican al instante. <strong>Writing y Speaking los revisa un profesor certificado</strong> — usa el microfono para grabarte hablando sobre un tema al azar.
          </div>
        </div>
        <div style={{ display:'flex', alignItems:'center', gap:12, background:'rgba(255,255,255,0.08)', borderRadius:12, padding:'12px 16px', marginBottom:28, textAlign:'left' }}>
          <span style={{ fontSize:20 }}>⏱</span>
          <div style={{ fontSize:13, opacity:.8 }}>Tiempo estimado: 18-25 minutos · Puedes saltarlo en cualquier momento</div>
        </div>
        <button onClick={() => setPaso('examen')}
          style={{ width:'100%', padding:'14px', background:'linear-gradient(135deg,#D4AF37,#B8912C)', color:'#0D1F52', border:'none', borderRadius:12, fontFamily:'inherit', fontSize:16, fontWeight:800, cursor:'pointer', marginBottom:12 }}>
          Comenzar examen
        </button>
        <button onClick={onSaltar}
          style={{ width:'100%', padding:'12px', background:'none', color:'rgba(255,255,255,0.5)', border:'none', fontFamily:'inherit', fontSize:14, cursor:'pointer', textDecoration:'underline' }}>
          Saltar examen, elegir plan directamente
        </button>
      </div>
    </div>
  )

  if (cargando) return (
    <div style={{ minHeight:'100vh', background:'linear-gradient(145deg,#0D1F52,#1B3A8C)', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:'system-ui, sans-serif' }}>
      <div style={{ textAlign:'center', color:'#fff' }}>
        <div style={{ fontSize:64, marginBottom:16 }}>🔍</div>
        <h2 style={{ fontSize:22, fontWeight:800, marginBottom:8 }}>Analizando tus resultados...</h2>
        <p style={{ opacity:.6 }}>Estamos calculando tu nivel de ingles</p>
      </div>
    </div>
  )

  if (paso === 'resultado' && resultado) {
    const nivelObjetivo = resultado.nivel_objetivo
    return (
      <div style={{ minHeight:'100vh', background:'linear-gradient(145deg,#0D1F52,#1B3A8C,#0a1836)', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:'system-ui, sans-serif', padding:20 }}>
        <div style={{ maxWidth:640, width:'100%' }}>
          <div style={{ background:'linear-gradient(135deg,' + COLORES_NIVEL[nivelObjetivo] + 'dd,' + COLORES_NIVEL[nivelObjetivo] + ')', borderRadius:20, padding:32, color:'#fff', textAlign:'center', marginBottom:20 }}>
            <div style={{ fontSize:64, marginBottom:8 }}>{nivelObjetivo === 'PRE' ? '🌱' : '🎉'}</div>
            <h1 style={{ fontSize:26, fontWeight:900, marginBottom:4 }}>Nivel base (Listening + Reading)</h1>
            <div style={{ fontSize:72, fontWeight:900, marginBottom:4 }}>{nivelObjetivo}</div>
            <div style={{ fontSize:15, opacity:.85 }}>
              {nivelObjetivo === 'PRE'
                ? 'Aun no confirmaste el nivel A1 completo — empezaremos desde lo basico'
                : `Nivel confirmado con dominio secuencial (referencia: ${resultado.puntaje_total_objetivo}% de aciertos)`}
            </div>
          </div>

          {/* Desglose "por que quedaste en este nivel" — lo que hace el resultado verificable */}
          <div style={{ background:'rgba(255,255,255,0.08)', backdropFilter:'blur(10px)', border:'1px solid rgba(255,255,255,0.15)', borderRadius:14, padding:20, color:'#fff', marginBottom:20 }}>
            <h3 style={{ fontSize:14, fontWeight:800, marginBottom:4 }}>🔍 Como se calculo tu nivel</h3>
            <p style={{ fontSize:12, opacity:.7, marginBottom:14, lineHeight:1.5 }}>
              Debias acertar las 2 preguntas de cada nivel para que ese nivel quedara confirmado y subir al siguiente.
            </p>
            {['listening','reading'].map(hab => (
              <div key={hab} style={{ marginBottom: hab === 'listening' ? 14 : 0 }}>
                <div style={{ fontSize:12, fontWeight:700, marginBottom:6, display:'flex', alignItems:'center', gap:6 }}>
                  <span>{HABILIDADES_INFO[hab].ic}</span> {HABILIDADES_INFO[hab].label}
                </div>
                <div style={{ display:'flex', gap:6 }}>
                  {['A1','A2','B1','B2','C1'].map(niv => (
                    <ChipNivel key={niv} nivel={niv} info={resultado['detalle_' + hab][niv]} />
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div style={{ display:'grid', gridTemplateColumns:'repeat(2,1fr)', gap:12, marginBottom:20 }}>
            {Object.entries(HABILIDADES_INFO).map(([key, info]) => {
              const puntaje = key === 'writing' ? resultado.puntaje_writing_estimado
                : key === 'speaking' ? resultado.puntaje_speaking_estimado
                : resultado['puntaje_' + key]
              const nivel = key === 'writing' ? resultado.nivel_writing_estimado
                : key === 'speaking' ? resultado.nivel_speaking_estimado
                : resultado['nivel_' + key]
              return (
                <div key={key} style={{ background:'rgba(255,255,255,0.08)', backdropFilter:'blur(10px)', border:'1px solid rgba(255,255,255,0.15)', borderRadius:14, padding:20, color:'#fff' }}>
                  <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:12 }}>
                    <span style={{ fontSize:22 }}>{info.ic}</span>
                    <span style={{ fontSize:14, fontWeight:700 }}>{info.label}</span>
                  </div>
                  <div style={{ fontSize:36, fontWeight:900, color: COLORES_NIVEL[nivel], marginBottom:4 }}>{nivel}</div>
                  <div style={{ height:6, background:'rgba(255,255,255,0.15)', borderRadius:999, overflow:'hidden', marginBottom:6 }}>
                    <div style={{ width: puntaje + '%', height:'100%', background: COLORES_NIVEL[nivel], borderRadius:999 }} />
                  </div>
                  <div style={{ fontSize:11, fontWeight:700, color: info.autoCalificado ? '#86EFAC' : '#FCD34D' }}>
                    {info.autoCalificado ? '✅ Confirmado' : '⏳ Estimado — pendiente de revision'}
                  </div>
                </div>
              )
            })}
          </div>

          <div style={{ background:'rgba(212,175,55,0.1)', border:'1px solid rgba(212,175,55,0.35)', borderRadius:14, padding:18, color:'#fff', marginBottom:20, display:'flex', gap:12 }}>
            <span style={{ fontSize:22 }}>👨‍🏫</span>
            <p style={{ fontSize:13, opacity:.9, lineHeight:1.6, margin:0 }}>
              Tu escritura y tu grabacion de voz seran revisadas por un profesor certificado apenas crees tu cuenta.
              Recibiras tu nivel final confirmado de Writing y Speaking por correo.
            </p>
          </div>

          <div style={{ background:'rgba(255,255,255,0.08)', backdropFilter:'blur(10px)', border:'1px solid rgba(255,255,255,0.15)', borderRadius:14, padding:20, color:'#fff', marginBottom:20 }}>
            <h3 style={{ fontSize:15, fontWeight:800, marginBottom:12 }}>📋 Plan recomendado (segun tu nivel base)</h3>
            {nivelObjetivo === 'PRE' ? (
              <p style={{ fontSize:13, opacity:.8, lineHeight:1.6 }}>
                Empezaras por <strong>Pre-A1</strong>: alfabeto, numeros, saludos y las bases para construir todo lo demas.
                Es el punto de partida ideal si es tu primer contacto real con el ingles.
              </p>
            ) : nivelObjetivo === 'A1' || nivelObjetivo === 'A2' ? (
              <p style={{ fontSize:13, opacity:.8, lineHeight:1.6 }}>
                Te recomendamos empezar con <strong>EnglishBridge Plus</strong> — cubre contenido A1-B1, perfecto para tu nivel actual.
              </p>
            ) : nivelObjetivo === 'B1' || nivelObjetivo === 'B2' ? (
              <p style={{ fontSize:13, opacity:.8, lineHeight:1.6 }}>
                Te recomendamos <strong>EnglishBridge Advanced</strong> — con contenido A1-C1 y clases privadas para acelerar tu progreso.
              </p>
            ) : (
              <p style={{ fontSize:13, opacity:.8, lineHeight:1.6 }}>
                Te recomendamos <strong>EnglishBridge Mastery</strong> — nuestra experiencia VIP con mentor personal para llegar a la fluidez total.
              </p>
            )}
          </div>

          <button onClick={continuarAResultado}
            style={{ width:'100%', padding:'14px', background:'linear-gradient(135deg,#D4AF37,#B8912C)', color:'#0D1F52', border:'none', borderRadius:12, fontFamily:'inherit', fontSize:16, fontWeight:800, cursor:'pointer' }}>
            Continuar a los planes →
          </button>
        </div>
      </div>
    )
  }

  const habInfo = HABILIDADES_INFO[habilidadActual]
  const preguntasHabilidadActual = PREGUNTAS.filter(p => p.habilidad === habilidadActual)
  const pregEnHabilidad = preguntasHabilidadActual.indexOf(pregunta) + 1

  return (
    <div style={{ minHeight:'100vh', background:'linear-gradient(145deg,#0D1F52,#1B3A8C,#0a1836)', fontFamily:'system-ui, sans-serif', padding:20 }}>
      <div style={{ maxWidth:680, margin:'0 auto' }}>
        <div style={{ marginBottom:16 }}>
          <button onClick={anterior}
            style={{ background:'none', border:'none', cursor:'pointer', fontSize:13, color:'rgba(255,255,255,0.6)', fontFamily:'inherit', display:'flex', alignItems:'center', gap:6, padding:0 }}>
            ← {pregActual === 0 ? 'Volver' : 'Pregunta anterior'}
          </button>
        </div>
        <div style={{ marginBottom:24 }}>
          <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:8 }}>
            <div style={{ display:'flex', alignItems:'center', gap:8, color:'#fff' }}>
              <span style={{ fontSize:20 }}>{habInfo.ic}</span>
              <span style={{ fontSize:14, fontWeight:700 }}>{habInfo.label}</span>
              <span style={{ fontSize:12, opacity:.6 }}>Pregunta {pregEnHabilidad}/{preguntasHabilidadActual.length}</span>
            </div>
            <span style={{ fontSize:12, color:'rgba(255,255,255,0.6)' }}>{pregActual + 1} de {PREGUNTAS.length}</span>
          </div>
          <div style={{ height:6, background:'rgba(255,255,255,0.15)', borderRadius:999, overflow:'hidden' }}>
            <div style={{ width: progreso + '%', height:'100%', background: habInfo.color, borderRadius:999, transition:'width .4s ease' }} />
          </div>
          <div style={{ display:'flex', gap:4, marginTop:8 }}>
            {['listening','reading','writing','speaking'].map(h => (
              <div key={h} style={{ flex:1, height:3, borderRadius:999,
                background: h === habilidadActual ? HABILIDADES_INFO[h].color :
                  PREGUNTAS.findIndex(p => p.habilidad === h) < pregActual ? 'rgba(255,255,255,0.4)' : 'rgba(255,255,255,0.1)' }} />
            ))}
          </div>
        </div>

        <div style={{ background:'rgba(255,255,255,0.06)', backdropFilter:'blur(20px)', border:'1px solid rgba(255,255,255,0.15)', borderRadius:20, padding:32, color:'#fff' }}>

          {pregunta.tipo === 'grabacion_libre' ? (
            <>
              <div style={{ fontSize:12, opacity:.6, textTransform:'uppercase', letterSpacing:1, marginBottom:8 }}>
                {habInfo.label} Task
              </div>
              <p style={{ fontSize:14, opacity:.8, marginBottom:20, lineHeight:1.6, fontStyle:'italic' }}>
                Habla en ingles sobre el tema que te aparece abajo. Te daremos 15 segundos para prepararte antes de empezar a grabar.
              </p>
              <GrabadorSpeaking
                key={pregunta.id}
                tema={temaActual}
                duracionMinima={pregunta.duracionMinima}
                onGrabacionLista={datos => responder(datos)}
              />
            </>
          ) : (
            <>
              <div style={{ fontSize:12, opacity:.6, textTransform:'uppercase', letterSpacing:1, marginBottom:8 }}>
                {habInfo.label} · Nivel {pregunta.nivel}
              </div>
              <p style={{ fontSize:14, opacity:.8, marginBottom:20, lineHeight:1.6, fontStyle:'italic' }}>
                {pregunta.instruccion}
              </p>

              {pregunta.audio_texto && (
                <div style={{ background:'rgba(255,255,255,0.08)', borderRadius:12, padding:16, marginBottom:20 }}>
                  <div style={{ display:'flex', alignItems:'flex-start', gap:12 }}>
                    <button onClick={() => hablar(pregunta.audio_texto)}
                      style={{ background: habInfo.color, border:'none', borderRadius:10, width:40, height:40, cursor:'pointer', fontSize:18, flexShrink:0, display:'flex', alignItems:'center', justifyContent:'center' }}>
                      🔊
                    </button>
                    <p style={{ fontSize:14, lineHeight:1.7, opacity:.9, margin:0 }}>{pregunta.audio_texto}</p>
                  </div>
                </div>
              )}

              {pregunta.texto && (
                <div style={{ background:'rgba(255,255,255,0.08)', borderRadius:12, padding:16, marginBottom:20 }}>
                  <p style={{ fontSize:14, lineHeight:1.8, opacity:.9, margin:0 }}>{pregunta.texto}</p>
                </div>
              )}

              <h2 style={{ fontSize:17, fontWeight:700, marginBottom:20, lineHeight:1.5 }}>{pregunta.pregunta}</h2>

              {(pregunta.tipo === 'audio_opcion' || pregunta.tipo === 'texto_opcion' || pregunta.tipo === 'completar') && (
                <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
                  {pregunta.opciones.map((op, i) => {
                    const seleccionada = respuestas[pregunta.id] === i
                    return (
                      <button key={i} onClick={() => responder(i)}
                        style={{ padding:'13px 18px', border:'1.5px solid ' + (seleccionada ? habInfo.color : 'rgba(255,255,255,0.2)'),
                          borderRadius:10, background: seleccionada ? habInfo.color + '33' : 'rgba(255,255,255,0.04)',
                          color:'#fff', fontFamily:'inherit', fontSize:14, cursor:'pointer', textAlign:'left',
                          display:'flex', alignItems:'center', gap:12, transition:'all .15s' }}>
                        <span style={{ width:28, height:28, borderRadius:'50%', background: seleccionada ? habInfo.color : 'rgba(255,255,255,0.15)',
                          display:'flex', alignItems:'center', justifyContent:'center', fontSize:12, fontWeight:800, flexShrink:0 }}>
                          {String.fromCharCode(65 + i)}
                        </span>
                        {op}
                      </button>
                    )
                  })}
                </div>
              )}

              {pregunta.tipo === 'texto_libre' && (
                <div>
                  <textarea value={textoLibre} onChange={e => setTextoLibre(e.target.value)}
                    placeholder="Escribe tu respuesta en ingles aqui..."
                    style={{ width:'100%', minHeight:120, padding:'12px 14px', border:'1.5px solid rgba(255,255,255,0.2)', borderRadius:10, fontFamily:'inherit', fontSize:14, outline:'none', resize:'vertical', lineHeight:1.6, boxSizing:'border-box', background:'rgba(255,255,255,0.08)', color:'#fff' }}
                  />
                  <div style={{ fontSize:12, opacity:.6, marginTop:6 }}>
                    {textoLibre.trim().split(/\s+/).filter(Boolean).length} / {pregunta.minPalabras} palabras minimo
                  </div>
                </div>
              )}
            </>
          )}

          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginTop:24 }}>
            <button onClick={onSaltar}
              style={{ background:'none', border:'none', color:'rgba(255,255,255,0.4)', fontSize:12, cursor:'pointer', fontFamily:'inherit' }}>
              Saltar examen
            </button>
            <button onClick={siguiente} disabled={!puedeAvanzar()}
              style={{ padding:'11px 28px', background: puedeAvanzar() ? habInfo.color : 'rgba(255,255,255,0.15)',
                color: puedeAvanzar() ? '#fff' : 'rgba(255,255,255,0.4)',
                border:'none', borderRadius:10, fontFamily:'inherit', fontSize:14, fontWeight:700,
                cursor: puedeAvanzar() ? 'pointer' : 'not-allowed', transition:'all .15s' }}>
              {pregActual < PREGUNTAS.length - 1 ? 'Siguiente' : 'Ver mis resultados'}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
